import React from 'react';
import Avatar, { type AppearanceType } from '@atlaskit/avatar';
import { Flex, Text } from '@atlaskit/primitives/compiled';

type CellWithAvatarProps = {
	imageUrl: string;
	appearance?: AppearanceType;
	text: string;
};

export const CellWithAvatar = ({
	imageUrl,
	appearance = 'circle',
	text,
}: CellWithAvatarProps): React.JSX.Element => (
	<Flex alignItems="center" gap="space.100">
		<Avatar src={imageUrl} size="small" appearance={appearance} />
		<Text>{text}</Text>
	</Flex>
);
